import { makeStyles, css, theme } from '@conexasaude/hero'

const useStyles = makeStyles({
  validateWrapper: () => css`
    .main-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      vertical-align: center;
      justify-content: center;
    }
    h2 {
      font-size: 18px;
      color: ${theme.colors.neutral[900]};
      font-weight: bold;
      line-height: 32px;
      margin-bottom: 8px;
      margin-top: 32px;
    }
    .no-attendance-wrapper {
      h2 {
        margin-bottom: 48px;
      }
    }
  `,
})

export default useStyles
